import Details from './Details';
import Content from './Content';
import Navigation from './Navigation';

export default Details;
export {
  Navigation,
  Content
};
